export enum StatusQuoAnalysisTabEnum {
  DEMAND = 'DEMAND',
  CONSUMPTION = 'CONSUMPTION',
  CLIMATE_RISKS = 'CLIMATE_RISKS',
}

export enum DisplayBaseEnum {
  PER_SQUARE_METER = 'per_square_meter',
  ABSOLUTE = 'absolute',
}

export enum DataCollectionTabActionsEnum {
  CREATE_ENERGY_CERTIFICATE_DRAFT = 'CREATE_ENERGY_CERTIFICATE_DRAFT',
  CREATE_ECONOMIC_UNIT = 'CREATE_ECONOMIC_UNIT',
}

export enum DataCollectionBuildingsTabEnum {
  BUILDINGS = 'BUILDINGS',
  ECONOMIC_UNITS = 'ECONOMIC_UNITS',
  ENERGY_CERTIFICATE_DRAFTS = 'ENERGY_CERTIFICATE_DRAFTS',
}

export enum DataCollectionEnergySuppliersTabEnum {
  ALL = 'ALL',
  VALID = 'VALID',
  EXPIRED = 'EXPIRED',
  DRAFTS = 'DRAFTS',
}

export enum EconomicUnitTabEnum {
  overview = 'overview',
  buildings = 'buildings',
  documents = 'documents',
}

export enum BuildingTabEnum {
  overview = 'overview',
  areas = 'areas',
  consumption = 'consumption',
  buildingModel = 'buildingModel',
  climateRisk = 'climateRisk',
  subsidies = 'subsidies',
  documents = 'documents',
}

/** @deprecated Old tab values kept for backward-compatible URL redirects */
export const LEGACY_BUILDING_TAB_REDIRECTS: Record<string, BuildingTabEnum> = {
  general: BuildingTabEnum.overview,
  digitalTwin: BuildingTabEnum.buildingModel,
  gisImmoRisk: BuildingTabEnum.climateRisk,
};

export enum BuildingSubTabEnum {
  technology = 'technology',
  envelope = 'envelope',
}

export enum ClimateRiskSubTabEnum {
  preCheck = 'preCheck',
  extended = 'extended',
}

export enum ConsumptionHubTabEnum {
  ALL_ENTRIES = 'ALL_ENTRIES',
  CBI = 'CBI',
  SMART_METERING = 'SMART_METERING',
  MANUAL_ENTRIES = 'MANUAL_ENTRIES',
  GAP_ANALYSIS = 'GAP_ANALYSIS',
}

export enum ConsumptionInvoicesTabEnum {
  PROCESSING = 'PROCESSING',
  OVERVIEW = 'OVERVIEW',
  ADDRESSES = 'ADDRESSES',
  DUPLICATES = 'DUPLICATES',
}

export enum PortfolioDisplayViewEnum {
  DASHBOARD = 'dashboard',
  LIST = 'list',
}

export enum ScenariosTabEnum {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export enum EnergyNetworkTabEnum {
  details = 'details',
  documents = 'documents',
  linkedEntities = 'linkedEntities',
}
